import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from '../../useAuth';
import { routes } from '../../routes/routes';
import { ReactComponent as UserSVG } from '../../../img/icons/user.svg';

const ProfileMenu = () => {
    const [dropdown, setDropdown] = useState(false);
    const { user, claim, signOut } = useAuth();
    const history = useHistory();

    const logout = () => {
        signOut(() => history.push(routes.login));
    };

    return (
        <div className="dropdown__trigger">
            <button className="button--avatar" onClick={() => setDropdown(!dropdown)}>
                <UserSVG className="avatar__image" />
            </button>
            {dropdown ? (
                <>
                    <div className="dropdown__overlay" onClick={() => setDropdown(false)}></div>
                    <div className="dropdown">
                        <div className="dropdown__info">
                            <div className="dropdown__email">{claim?.email}</div>
                            <div className="dropdown__role">{claim?.role}</div>
                        </div>
                        <button className="button button--small" onClick={logout}>
                            Sign out
                        </button>
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default ProfileMenu;
